module.exports = __webpack_public_path__ + "static/media/logo-펫핀스.f01b7a8c.png";